import { createContext, useContext, useEffect, useState } from "react";
import useData from "hooks/useData";

const MessageBoxContext = createContext({});

export const MessageBoxContextProvider = ({ children }) => {
  const [ refreshToken, setRefreshToken ] = useState();
  const [ selectedConversation, setSelectedConversation ] = useState();
  const [ conversations, setConversations ] = useState();
  const [ conversationsLoading, setConversationsLoading ] = useState(true);
  const [ filter, setFilter ] = useState('');

  const { getData } = useData();

  const refreshConversations = () => {
    setRefreshToken(Math.random());
  }

  useEffect(() => {
      const load = async () => {
        setConversationsLoading(true);
        setSelectedConversation(null);
        const { data } = await getData('rest/conversation', `limit=50&filter=${ filter }`); // @todo: remove hard limit and add a definitive solution like a pager
        setConversations(() => data);
        setConversationsLoading(false);
      }

      load();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ refreshToken, filter ]
  );

  return (
    <MessageBoxContext.Provider value={ {
      selectedConversation,
      refreshConversations,
      setSelectedConversation,
      conversations,
      setConversations,
      conversationsLoading,
      filter,
      setFilter,
    } }>
      { children }
    </MessageBoxContext.Provider>
  )
}

export function useMessageBox() {
  return useContext(MessageBoxContext);
}

export default MessageBoxContextProvider;
